/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homeaboutus2Inputs */



/**
* | output |
* | --- |
* | "About us" |
*
* @param {Homeaboutus2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homeaboutus2 = /** @type {((inputs?: Homeaboutus2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homeaboutus2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("About us")
	return /** @type {LocalizedString} */ ("Über uns")
});
export { homeaboutus2 as "homeAboutUs" }